import { styled } from 'styled-components';
import { blockStyle } from '../../../components/styles/Block';

export const ContentBlock = styled.div`
  ${blockStyle}
`;

// Inline: コンテンツサイズで高さが決まる
export const ContentInner = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;
